import { useQuery } from "@tanstack/react-query";

import { useApi } from "@/hooks";
import {
  registrationInstanceSchema,
  type RegistrationInstance,
} from "@/schemas";

function useRegistrationInstance() {
  const api = useApi();

  return useQuery<RegistrationInstance>({
    queryKey: ["registrations", "instance"],
    queryFn: async () => {
      const { data } = await api.get<RegistrationInstance>(
        "/api/v3/pepe/instance",
      );
      return registrationInstanceSchema.parse(data);
    },
  });
}

export { useRegistrationInstance };
